<template lang="html">
  <div id="branch-offices-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12 col-title-s1">
          <h3 class="title">Sucursales y contactos</h3>
        </div>

        <div class="col-lg-4 col-xl-3 col-branch-office" v-for="(office, key) in contents" :key="key">
          <div class="box">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+office.imgUrl+')' }"></div>

            <div class="descr">
              <a target="_blank" class="map-icon" href="https://goo.gl/maps/J3ieeJ19dV4BTe5x9">
                <i class="fas fa-map-marker-alt"></i>
              </a>

              <h6 class="name">{{ office.name }}</h6>
              <div v-html="office.address"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      contents: [
        { imgUrl: 'public/images/pages/branch-offices/pachuca.jpg', name: 'Pachuca centro', address: 'Plaza mayoreo del celular<br />Calle Ignacio allende #322 isla 9<br />Entre Doria y Victoria, Centro,<br />Pachuca hgo, C.P 42000' },
        { imgUrl: 'public/images/pages/branch-offices/el-salto.jpg', name: 'El Salto Jalisco', address: 'Carretera Gdl el salto #2100 local 13<br />Entre Benito Juárez y Carrillo<br />El verde<br />C.P 45694' },
        { imgUrl: 'public/images/pages/branch-offices/guadalajara.jpg', name: 'Guadalajara centro', address: 'Plaza Pasaje de la Tecnología<br />BLACKFON-MX10@BLACKFON-MX.con.mx<br />López Cotilla #337, Local 2<br />Gdl, centro.  ' },
        { imgUrl: 'public/images/pages/branch-offices/guadalajara-2.jpg', name: 'Guadalajara centro', address: 'Plaza comercial Centro Sur<br />Anillo Periférico Sur 7835 int. local A23<br />Santa María Tequepexpan<br />Tlaquepaque Jalisco<br />C.P. 45601' },
        // { imgUrl: 'public/images/pages/branch-offices/guadalajara.jpg', name: 'Guadalajara', address: 'Av. La Paz #582<br />Col. Centro, CP. 44800<br />Entre 16 de Septiembre y Calle 52<br />Tel: 33 4555 0000<br />Guadalajara, Jal.' },
        // { imgUrl: 'public/images/pages/branch-offices/guadalajara.jpg', name: 'Guadalajara', address: 'Av. La Paz #582<br />Col. Centro, CP. 44800<br />Entre 16 de Septiembre y Calle 52<br />Tel: 33 4555 0000<br />Guadalajara, Jal.' },
        // { imgUrl: 'public/images/pages/branch-offices/guadalajara.jpg', name: 'Guadalajara', address: 'Av. La Paz #582<br />Col. Centro, CP. 44800<br />Entre 16 de Septiembre y Calle 52<br />Tel: 33 4555 0000<br />Guadalajara, Jal.' },
      ],
    }
  },

  methods: {
    getContents: function(){
      axios.get(tools.url('/api/branchoffices')).then((response)=>{
        this.contents = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },
  },

  mounted(){
    // this.getContents();
  },
}
</script>
